import { createContext, useContext } from 'react';
import type { ItemKey } from '../../types';

export const SideMenuContext = createContext<{
  selectedKey: ItemKey;
  setSelectedKey: React.Dispatch<React.SetStateAction<ItemKey>>;
  onSelectedKeyChange: (selectedKey: ItemKey) => void;
}>({} as never);

export function useSideMenu() {
  return useContext(SideMenuContext);
}
